/**
 * Prevents orphaned words in text by replacing the last space with a non-breaking space
 * @param {string} text - The text to process
 * @returns {string} - The text with the last word protected from being orphaned
 */
export const preventOrphan = (text) => {
  if (!text) return '';
  
  const words = text.split(' ');
  if (words.length <= 1) return text;
  
  const lastWord = words.pop();
  return [...words, '\u00A0' + lastWord].join(' ');
};

/**
 * Ensures a product title uses exactly two lines, keeping all words
 * @param {string} title - The product title to format
 * @returns {string} - The formatted title with all words split into two lines
 */
export const ensureTwoLines = (title) => {
  if (!title) return '';
  
  const words = title.split(' ').filter(word => word.trim());
  
  // If only one word, add empty second line
  if (words.length === 1) {
    return words[0] + '\n';
  }
  
  // For two or more words, split into two lines
  const midPoint = Math.ceil(words.length / 2);
  const firstLine = words.slice(0, midPoint).join(' ');
  const secondLine = words.slice(midPoint).join(' ');
  
  return firstLine + '\n' + secondLine;
};

/**
 * Combines both functions to ensure a product title is properly formatted
 * @param {string} title - The product title to format
 * @returns {string} - The formatted title with two lines and no orphans
 */
export const formatProductTitle = (title) => {
  const twoLineTitle = ensureTwoLines(title);
  return twoLineTitle.split('\n').map(line => preventOrphan(line)).join('\n');
}; 